import React, { useState, useEffect, useLayoutEffect } from 'react';
import { Routes, Route, Link, NavLink, useParams, useLocation } from 'react-router-dom';

import { isMobile, isTablet } from 'react-device-detect';

//services
import PlaceService from '../../../services/place'

//auth
import { useAuth } from '../../../context/AuthProvider'

function Place() {

    const location = useLocation();

    //validation auth
    const auth = useAuth();

    //get category
    const [categoryGet, setCategoryGet] = useState('');

    useEffect(() => {
        onLoadCategory();
    }, []);


    //get first load places
    const onLoadCategory = async () => {
        try {
            let bearer_Token = {
                'headers': {
                    'Authorization': `Bearer ${auth.authToken()}`
                }
            };
            const getAllplace = await PlaceService.getAllplaceCms(bearer_Token);
           // console.log(getAllplace.data);
            if (getAllplace.status === 200 && getAllplace.data.statusCode === 201) {
                setCategoryGet(getAllplace.data.data);
            } else if (getAllplace.status === 200 && getAllplace.data.statusCode === 404) {
            } else if (getAllplace.status === 200 && getAllplace.data.output.statusCode === 400) {
            } else {
            }
        } catch (error) {
            //console.log(error.response.status)
        }
    }
    return (
        <>
            <div className='container pd-4'>
                <h4 className="text-center">PLACES</h4>
                <div className='row'>
                    <div className='col-6'>
                        <div className="btn-group" role="group">
                            <Link to={'/new-place'} type="button" className="btn btn-outline-success btn-sm">New <i className="fa-solid fa-plus"></i></Link>
                        </div>
                    </div>
                    <div className='pd-4'>
                        <table className="table table-hover">
                            <thead>
                                <tr className='table-dark'>
                                    <th scope="col">Image</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Description</th>
                                    <th scope="col">Status</th>
                                    <th scope="col">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Array.isArray(categoryGet) ? (
                                    categoryGet.map((item, i) => (
                                        <tr key={i}>
                                            <th><img src={item.plaImage} /></th>
                                            <td className='text-table'>{item.plaName ? item.plaName : ''}</td>
                                            <td className='text-table'>{item.plaDescription ? item.plaDescription.slice(0, 20) : ''}</td>

                                            <td><span className={`badge  ${item.plaActive === '1' ? 'text-bg-success' : 'text-bg-secondary'}`}>{item.plaActive === '1' ? 'active' : 'disabled'} </span></td>
                                            <td><div className="btn-group" role="group">
                                                <Link to={`/edit-place/${item.plaId}`} type="button" className="btn btn-warning btn-sm">Edit <i className="fa-solid fa-pen"></i></Link>
                                            </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr className='placeholder-glow'>
                                        <th ><span className="placeholder col-12"></span></th>
                                        <td ><span className="placeholder col-12"></span></td>
                                        <td ><span className="placeholder col-12"></span></td>
                                        <td > <span className="placeholder col-12"></span></td>
                                        <td ><span className="placeholder col-12"></span> </td>
                                        <td ><span className="placeholder col-12"></span> </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}
export { Place }